export default __webpack_public_path__ + "static/media/sidebar-4.9c1c33a0.png";